import { render, staticRenderFns } from "./file-gallery.vue?vue&type=template&id=68460bf8&"
import script from "./file-gallery.js?vue&type=script&lang=js&"
export * from "./file-gallery.js?vue&type=script&lang=js&"
import style0 from "./file-gallery.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports